<div class="widget-container" #lineCharDiv>
    <line-chart
    [headerConfig]="item.config?.widget_header_config"
    [heading]="heading"
    [config]="config"
    [data]="data"
    [item]="item"
    [pageKey]="pageKey"
    [error_name]="error_name"
    >
    </line-chart>
</div>